<template>
  <div class="gp-tabs-nav">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "GpTabsNav"
};
</script>